import over from "@/views/over/over.vue";


export default {
  path: "/over",
  component: { render: (c) => c("router-view") },
  children: [
    {
      path: "over",
      name: "over",
      component: over,
    },
  ],
};
